module.exports = __webpack_public_path__ + "static/media/quiz-cantar.399b3fc4.png";